import api from '../../../config/api';

// eslint-disable-next-line import/prefer-default-export
export const OrganizationService = {
	async getOrganizationListService() {
		const result = await api
			.get(`${process.env.REACT_APP_API_ENDPOINT}api/listeOrga/filiale`)
			.then((response) => response)
			.catch((err) => ({
				status: err.response.status,
				data: null,
			}));

		return result;
	},
};
